import React from 'react';
import { MultiStepModal } from '@components/common/multiStepModal';

import { AccountTypePickerModalStep } from './steps/accountTypePickerModalStep';
import { AccountTypeFormModalStep } from './steps/accountTypeFormModalStep';

interface CreateAccountModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateAccountModal: React.FC<CreateAccountModalProps> = ({ open, onClose }) => (
  <MultiStepModal
    showCross
    steps={[
      {
        key: 'accountTypePicker',
        title: 'Create account to connect',
        component: () => <AccountTypePickerModalStep />,
      },
      {
        key: 'accountTypeForm',
        title: 'Configure account',
        component: () => <AccountTypeFormModalStep />,
      },
    ]}
    open={open}
    onClose={onClose}
    breadcrumb={{ hide: true }}
    size="lg"
  />
);
